import web from "../web";

class RolesService {
    index(token){
        return web.get("/api/roles", { headers: { 'Authorization': 'Bearer '+token } })
    }
    store(data, token){
        return web.post("/api/roles", data, { headers: { 'Authorization': 'Bearer '+token } })
    }

    show(id,token){
        return web.get(`/api/roles/${id}/show`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    update(data,token){
        return web.put("/api/roles/update", data,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    delete(id,token){
        return web.delete(`/api/roles/${id}/delete`,{ headers: { 'Authorization': 'Bearer '+token } })
    }
}

export default new RolesService()